// noinspection JSUnusedGlobalSymbols
export default () => ({
    entities: {},
})
